import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Home from './containers/pages/Home';
import Blog from './containers/pages/Blog';
import BlogPost from './containers/pages/BlogPost';
import EmmpiezaCv from './containers/pages/EmmpiezaCv';
import Proyectos from './containers/pages/Proyectos';
import Error404 from './containers/errors/Error404';
import Contacto from './components/home/Contacto';
import PoliticaPrivacidad from './containers/pages/PoliticaPrivacidad';
import PoliticaDatos from './containers/pages/PoliticaDatos';
import About from './containers/pages/About';
import ExpertisePage, { AviationPage } from './containers/pages/ExpertisePage';
import RouteSeo from './components/common/Seo';
import { KnowledgePage, CaseStudyPage } from './containers/pages/AuthorityPage';


function App() {
  return (
    <ThemeProvider>
      <Router>
        <RouteSeo />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<About />} />
          <Route path="/servicios/inteligencia-artificial" element={<ExpertisePage service="inteligencia-artificial" />} />
          <Route path="/servicios/software-y-aplicaciones" element={<ExpertisePage service="software-y-aplicaciones" />} />
          <Route path="/servicios/ciberseguridad" element={<ExpertisePage service="ciberseguridad" />} />
          <Route path="/ia-aviacion-seguridad-operacional" element={<AviationPage />} />
          <Route path="/conocimiento/:slug" element={<KnowledgePage />} />
          <Route path="/casos/:slug" element={<CaseStudyPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/analiza-tu-cv" element={<EmmpiezaCv />} />
          <Route path="/proyectos" element={<Proyectos />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/politica-datos" element={<PoliticaDatos />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
